module.exports = "<div class=\"grid-container\">\n  <h1 class=\"mat-h1\">{{ 'activities_title' | translate }}</h1>\n</div>\n"